export default __webpack_public_path__ + "static/media/Patronato-piticocha.b067189e.jpg";